/**
 * Hex fallbacks for non-Tailwind contexts (e-mails, prompts, inline styles, SSR strings).
 * Keep in sync with `web-app/styles/jc-public-theme.css` (`:root` / `html.dark`).
 */
export const jcThemeHex = {
  light: {
    page: '#F8F5F0',
    surface: '#FFFFFF',
    elevated: '#F2EADF',
    elevatedHover: '#EDE3D4',
    border: '#DDD5C8',
    canvasDeep: '#F8F5F0',
    /** Default green logo tile — sync with --jc-logo-gen-mid / --jc-logo-matte */
    logoMatte: '#3B5E45',
    /** Card background tile for transparent non-mono logos — sync with --jc-logo-surface */
    logoSurface: '#FFFFFF',
    /** Very light green tile for mono black marks on alpha — sync with --jc-logo-mono-light */
    logoMonoLight: '#C8DDCE',
    /** Dark green tile for mono white marks on alpha — sync with --jc-logo-mono-dark */
    logoMonoDark: '#2A4533',
    /** @deprecated Prefer `logoMonoLight` / `logoMonoDark`. */
    logoMonoTan: '#C8DDCE',
    ink: '#16150F',
    inkSecondary: '#4A4438',
    muted: '#8C8474',
    onElevated: '#5A4A3A',
    contrastSubtle: '#8A7060',
    accent: '#3B5E45',
    cta: '#3B5E45',
    ctaHover: '#2A4533',
    accentMuted: '#C8DDCE',
    accentSoft: '#5A8A68',
    gold: '#6E4F00',
    goldBg: '#F5EDD0',
    goldLine: '#B8860B',
    positive: '#3B5E45',
    negative: '#B3453D',
    cardBorder: 'rgba(22, 21, 15, 0.08)',
    chipTanBg: '#DDD5C8',
    chipTanText: '#5A3E20',
    filterLocationBg: '#A8C9C8',
    filterLocationText: '#1A2E2E',
    filterLocationBorder: '#4A7B79',
    filterSalaryBg: '#F5EDD0',
    filterSalaryText: '#6E4F00',
    filterSalaryBorder: '#B8860B',
    filterCompanyBg: '#D9A89A',
    filterCompanyText: '#3D1810',
    filterCompanyBorder: '#9A4F3C',
    filterJobBg: '#C8DDCE',
    filterJobText: '#2A4533',
    filterJobBorder: '#3B5E45',
    skeleton: '#D5CDC0',
  },
  dark: {
    page: '#170F07',
    surface: '#1F1509',
    elevated: '#2A1D0F',
    elevatedHover: '#342415',
    border: '#4A3520',
    canvasDeep: '#0E0A04',
    logoMatte: '#2D4A38',
    logoSurface: '#1F1509',
    logoMonoLight: '#1A2E22',
    logoMonoDark: '#5A8A68',
    /** @deprecated Prefer `logoMonoLight` / `logoMonoDark`. */
    logoMonoTan: '#1A2E22',
    ink: '#F2EADF',
    inkSecondary: '#C4A882',
    muted: '#9A917F',
    onElevated: '#C4A882',
    contrastSubtle: '#8A7060',
    accent: '#98CFA8',
    cta: '#3B5E45',
    ctaHover: '#5A8A68',
    accentMuted: '#1A2E22',
    accentSoft: '#5A8A68',
    gold: '#D4A820',
    goldBg: '#2A1E08',
    goldLine: '#D4A820',
    positive: '#98CFA8',
    negative: '#E08277',
    cardBorder: 'rgba(74, 53, 32, 0.7)',
    chipTanBg: '#2A1D0F',
    chipTanText: '#D4B898',
    filterLocationBg: '#1A3030',
    filterLocationText: '#9FD5D3',
    filterLocationBorder: '#4D8F8D',
    filterSalaryBg: '#2A1E08',
    filterSalaryText: '#EEC85A',
    filterSalaryBorder: '#D4A820',
    filterCompanyBg: '#3D221C',
    filterCompanyText: '#E8B0A0',
    filterCompanyBorder: '#B8624A',
    filterJobBg: '#1A2E22',
    filterJobText: '#98CFA8',
    filterJobBorder: '#5A8A68',
    skeleton: '#5C4535',
  },
} as const;
